var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-container width-100 display-flex flex-column",style:({ 'max-width': _vm.maxWidth })},[_c('div',{staticClass:"header-container width-100 flex-centerize"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content-container flex-centerize flex-column text-center"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }